import { FileKind } from "../../../define/FileKind";
import { BaseLocalDataInfos } from "../base/BaseLocalData";

export default class MatchMiaiData extends BaseLocalDataInfos {

    /** 当前正在使用的装备 */
    curUseEquip: string = '';
    
    /** 已拥有的装备 */
    ownEquipList: string[] = [];

    /** 装备观看广告次数 [1,2] 第一个值是装备id，第二个值是次数 */
    adEquipCount: string[] = [];

    /** 通关第一关 */
    bEndGame: boolean = false;
    /** 第二关通关 */
    bEndSecond: boolean = false;
    /** 是否支付过彩礼 */
    bBridePrice: boolean = false;

    /** 是否显示丘比特之箭 */
    bShowCupidArrow: boolean = false;
    /** 是否开启彩礼倒计时 */
    bOpenBridePriceDTime: boolean = false;
    /** 彩礼倒计时开始时间 */
    bridePrriceStartTime: number = 0;
    /** 参加比赛次数 */
    joinMatchCount: number = 0;
   
    getLocalDataKey() {
        return FileKind.SaveLocalDataKey.MILITARY_CITY_DATA;
    }
}
